<!--Copy right - © 2024 tecera gmbh-->
<!-- ResetPasswordForm.svelte -->
<script>
    import { Link } from "svelte-routing";
    import {
        login_info_message,
        check_if_email_is_registered,
        reset_password,
    } from "../../scripts/auth.js";
    import { navigate } from "svelte-routing";
    import { onMount } from "svelte";
    import { PASSWORD_REGEX } from "../../config.js";
    const STATES = {
        RESET_OLD_PASSWORD: "reset",
        ENTER_NEW_PASSWORD: "aktualisieren",
    };
    let current_state = STATES.RESET_OLD_PASSWORD;
    let username = "",
        verification_code = "",
        password = "",
        password_confirm = "";
    let submit_button, form, autofocus_input; // Identity of components
    let error_message, info_message; // if any message exists it will be displayed until cleared
    let is_loading = false; // Bool for displaying loading spinner

    onMount(() => {
        autofocus_input.focus();
    });

    // form submit function
    async function handle_submit(event) {
        is_loading = true;
        error_message = null;
        event.preventDefault(); // prevent autosubmit so form wont get cleared and make wrong http request
        if (form.checkValidity()) {
            if (current_state === STATES.RESET_OLD_PASSWORD) {
                const response = await check_if_email_is_registered(username);
                if (response["status"] === "success") {
                    error_message = null;
                    info_message =
                        "Bitte geben Sie den Verifizierungscode aus der soeben erhaltenen E-Mail mit einem neuen Passwort ein.";
                    current_state = STATES.ENTER_NEW_PASSWORD;
                } else {
                    error_message = response["message"];
                }
            } else {
                info_message = null;
                if (check_password()) {
                    const response = await reset_password(
                        username,
                        password,
                        verification_code,
                    );
                    if (response["status"] === "success") {
                        error_message = null;
                        navigate("/");
                        $login_info_message =
                            "Passwort wurde erfolgreich geändert. Bitte melden Sie sich an.";
                    } else {
                        error_message = response["message"];
                    }
                }
            }
        }

        is_loading = false;
    }

    function check_password() {
        const regex = new RegExp(PASSWORD_REGEX);
        if (!regex.test(password) || !regex.test(password)) {
            error_message = "Passwort muss mindestens 8 Zeichen enthalten."; // TODO: Sonderzeichen
        } else if (password !== password_confirm) {
            error_message = "Passwörter stimmen nicht überein.";
        } else {
            return true;
        }
        return false;
    }
</script>

<form class="form-signin" style="padding-left: 5px;padding-right:5px;" on:submit={handle_submit} bind:this={form}>
    <!-- Logo-->
    <img
        src="img/250105_Logo_Bach_myBach_Logo_White_small.svg"
        alt="Login_logo"
    />

    <p class="login-headline">
        {current_state === STATES.RESET_OLD_PASSWORD
            ? "Passwort zurücksetzen"
            : "Passwort aktualisieren"}
    </p>

    <!-- Warning message -->
    {#if error_message}
        <div class="alert alert-warning" role="alert">
            <i class="fa-solid fa-triangle-exclamation"
            ></i>&nbsp;&nbsp;{error_message}
        </div>
    {:else if info_message}
        <div class="alert alert-info" role="alert">
            <i class="fa-solid fa-circle-info"></i>&nbsp;&nbsp;{info_message}
        </div>
    {/if}

    <!-- Input - Username -->
    <div class="input-group login-input">
        <div class="icon-container">
            <i class="fa fa-user login-icon"></i>
        </div>
        <input
            bind:this={autofocus_input}
            bind:value={username}
            type="email"
            id="username"
            name="inputUser"
            class="form-control login-input ml-2 pl-2"
            style="border:none; margin-bottom:-1px; {current_state ===
            STATES.RESET_OLD_PASSWORD
                ? ''
                : 'opacity:0.7;'}"
            placeholder="E-Mail"
            required
            autocomplete="username"
            maxlength="64"
            disabled={current_state === STATES.ENTER_NEW_PASSWORD}
        />
    </div>

    {#if current_state === STATES.ENTER_NEW_PASSWORD}
        <!-- Folgende Input Felder im default versteckt, werden nach Zurücksetzen sichtbar -->
        <div class="input-group login-input">
            <div class="icon-container">
                <i class="fa fa-key login-icon"></i>
            </div>
            <input
                bind:value={verification_code}
                type="text"
                id="verifizierungscode"
                name="verifyCode"
                class="form-control login-input ml-2 pl-2"
                style="border:none; margin-bottom:-1px"
                placeholder="Verifizierungscode"
                required
                autocomplete="off"
                maxlength="64"
            />
        </div>

        <!-- Input - Password -->
        <div class="input-group login-input">
            <div class="icon-container">
                <i class="fa fa-lock login-icon"></i>
            </div>
            <input
                bind:value={password}
                type="password"
                id="password"
                class="form-control login-input ml-2 pl-2"
                style="border:none; margin-bottom:-1px"
                placeholder="Passwort"
                required
                autocomplete="new-password"
                maxlength="64"
            />
        </div>

        <!-- Input - Password -->
        <div class="input-group login-input">
            <div class="icon-container">
                <i class="fa fa-lock login-icon"></i>
            </div>
            <input
                bind:value={password_confirm}
                type="password"
                id="check_password"
                class="form-control login-input ml-2 pl-2"
                style="border:none; margin-bottom:-1px"
                placeholder="Passwort wiederholen"
                required
                autocomplete="new-password"
                maxlength="64"
            />
        </div>
    {/if}

    <!-- Reset Button -->
    <div
        style="display:flex;flex-direction:column;justify-content:space-between;"
    >
        <button
            bind:this={submit_button}
            type="submit"
            class="btn btn-lg btn-tertiary btn-block mb-4"
            style="font-size: 18px; font-weight: 550; display: flex; justify-content: center; align-items: center;"
        >
            {#if is_loading}
                <div
                    id="loader"
                    class="loader_small"
                    style="position:relative"
                />
            {:else}
                <div>
                    {current_state === STATES.RESET_OLD_PASSWORD
                        ? "Zurücksetzen "
                        : "Aktualisieren "}<i class="fa fa-sign-in"></i>
                </div>
            {/if}
        </button>

        <div class="login-row" style="justify-content: center;">
            <Link
                to="/"
                class="btn btn-link "
                style="font-size: 1rem; font-weight: 550; white-space: wrap;color:var(--tertiary);"
                >Zurück zur Anmeldung
            </Link>
        </div>
    </div>
</form>
